import { FC } from "react";
import { ISVG } from "types/ISVG";

export const DeleteFileButtonSVG: FC<ISVG> = ({width, height, className}) => {
  return (
    <svg className={className} width={width} height={height} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24.3086 13.8906C24.3086 8.13693 19.6443 3.47266 13.8906 3.47266C8.13693 3.47266 3.47266 8.13693 3.47266 13.8906C3.47266 19.6443 8.13693 24.3086 13.8906 24.3086C19.6443 24.3086 24.3086 19.6443 24.3086 13.8906Z" fill="white"/>
        <path d="M17.166 10.6152L10.6143 17.1669" stroke="#AEAEAE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17.166 17.1669L10.6143 10.6152" stroke="#AEAEAE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

